import { GetterTree } from "vuex";
import { RootState } from "..";
import { State } from "./state";
import DeviceInfo from "@/models/deviceInfo.model";
import { getCircleColor, getIconColor } from "@/utils/utils";

interface FilterOptions {
  text: string;
  value: string;
}

interface Filters {
  recovery: FilterOptions[];
  identification: FilterOptions[];
  lifetime: FilterOptions[];
  temperature: FilterOptions[];
  battery: FilterOptions[];
  id: FilterOptions[];
  label: FilterOptions[];
}

export interface Getters {
  devices: DeviceInfo[];
  devicesWithLocations: DeviceInfo[];
  isLiveDataConnected: boolean;
  markers: any[];
  events: any[];
  filters: Filters;
  selectedDevice: DeviceInfo | undefined;
}
const getFilterOptions = (items: any[]) => {
  return [...new Set(items)].sort((a, b) => a - b).map((item) => ({value: item, text: item}));
};

export const getters: GetterTree<State, RootState> = {
  devices(state): DeviceInfo[] {
    return state.devices ?? [];
  },
  devicesWithLocations(state): DeviceInfo[] {
    return (state.devices ?? []).filter((device) => device.status?.reported?.location);
  },
  isLiveDataConnected(state): boolean {
    return state.liveDataConnected;
  },
  markers(state): any[] {
    return (state.devices ?? [])
      .filter((device) => device.visible && device.status?.reported?.location)
      .map((device) => ({
        position: {
          lat: device.status.reported.location.data.lat,
          lng: device.status.reported.location.data.lng,
        },
        locationInfo: {
          updatedAt: device.status.reported.location.date,
          label: device.label ?? device.id,
          route: "/devices/" + device.id,
          id: device.id
        },
        center: {
          lat: device.status.reported.location.data.lat,
          lng: device.status.reported.location.data.lng,
        },
        radius: device.status.reported.location.data.accuracy ?? 100,
        options: {
          fillColor: getCircleColor(device.live ? 1 : 0),
          strokeColor: getCircleColor(device.live ? 1 : 0)
        },
        icon: getIconColor(device.live ? 1 : 0)
      }));
  },
  events(state): any[] {
    return state.events ?? [];
  },
  filters(state): Filters {
    return {
      recovery: getFilterOptions(state.devices.map((x) => x.currentState.recovery)),
      identification: getFilterOptions(state.devices.map((x) => x.currentState.identification)),
      lifetime: getFilterOptions(state.devices.map((x) => x.currentState.lifetime)),
      temperature: getFilterOptions(state.devices.map((x) => x.currentState.temperature)),
      battery: getFilterOptions(state.devices.map((x) => x.currentState.battery)),
      id: getFilterOptions(state.devices.map((x) => x.id)),
      label: getFilterOptions(state.devices.map((x) => x.label)),
    } as Filters;
  },
  selectedDevice(state): DeviceInfo | undefined {
    return state.devices.find((d) => d.id === state.selectedDevice);
  }
};
